module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/80/assets/images/4c3a3689e448859369e9eeb8999bb8f9.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/UPF/icons/ico_gem_3.svg
// module id = nIML
// module chunks = 0